import { requestWithAuth } from "@/utils/authUtils";
import { normalizeLanguageKey } from "@/constants/languageMap";

const audioCache = new Map();

// Speed isn't part of the key: playback speed is applied in the browser.
const buildCacheKey = (text, language, voice) =>
  `${text}::${language || ""}::${voice || ""}`;

const TextToSpeechService = {
  async fetchAudioUrl(text, language, { speed = 1, voice } = {}) {
    const trimmedText = (text || "").trim();
    if (!trimmedText) {
      return null;
    }

    const normalizedLanguageKey = normalizeLanguageKey(language);
    const ttsLanguage =
      normalizedLanguageKey?.replace(/_/g, "-") || language || undefined;

    const key = buildCacheKey(trimmedText, ttsLanguage, voice);
    if (audioCache.has(key)) {
      return audioCache.get(key);
    }

    const payload = {
      text: trimmedText,
      language: ttsLanguage,
      speed,
      voice,
    };

    const response = await requestWithAuth(
      "/tts/speak",
      "POST",
      payload,
      undefined
    );

    if (!response?.audio) {
      return null;
    }

    const format = response.format || "mp3";
    const dataUrl = `data:audio/${format};base64,${response.audio}`;
    audioCache.set(key, dataUrl);
    return dataUrl;
  },

  clearCache() {
    audioCache.clear();
  },
};

export default TextToSpeechService;
